import type { Metric } from 'web-vitals'
import { pushEvent } from './analytics'

// crux has no field data for this domain, so real-user timings come from here
// instead. not the plugin's enableWebVitalsTracking — it pins web-vitals@1 and
// reports the retired FID rather than INP.

const report = (metric: Metric) => {
  pushEvent('web_vitals', {
    metric_name: metric.name,
    // ga4 aggregates integers better; cls is a fraction, so scale it and divide
    // back in the report
    metric_value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
    metric_rating: metric.rating,
    metric_id: metric.id,
  })
}

export const trackWebVitals = () => {
  if (typeof window === 'undefined') return

  // dynamic so the library doesn't compete for bandwidth with what it measures.
  // registering after hydration loses nothing — web-vitals reads buffered
  // PerformanceObserver entries.
  void import('web-vitals')
    .then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
      onLCP(report)
      onCLS(report)
      onINP(report)
      // not core web vitals, but they split lcp into server time and first paint
      onFCP(report)
      onTTFB(report)
    })
    .catch(() => {
      /* no measurements is not worth an error in a visitor's console */
    })
}
